import AddTrendButton from "./AddTrendButton";

export default AddTrendButton;
